import { render, staticRenderFns } from "./MobileSuggestions.vue?vue&type=template&id=56044352"
import script from "./MobileSuggestions.vue?vue&type=script&lang=js"
export * from "./MobileSuggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports